/* DOM slide-out cart: add to bag without leaving the page, open from the header, change quantities. */
(function () {
  function root() { return document.querySelector('[data-dom-cart]'); }
  function sectionId() {
    var r = root(); if (!r) return null;
    var w = r.closest('.shopify-section');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function setCount(n) {
    document.querySelectorAll('[data-dom-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function refresh() {
    var id = sectionId(); if (!id) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[id]) return;
        var tmp = document.createElement('div'); tmp.innerHTML = data[id];
        var fresh = tmp.querySelector('[data-dom-cart]'); var r = root();
        if (fresh && r) {
          var open = r.classList.contains('is-open');
          r.innerHTML = fresh.innerHTML;
          if (open) { r.hidden = false; r.classList.add('is-open'); }
        }
      });
  }
  function open() {
    var r = root(); if (!r) { window.location.href = '/cart'; return; }
    r.hidden = false;
    requestAnimationFrame(function () { r.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var p = r.querySelector('.dcd-panel'); if (p) p.focus();
  }
  function close() {
    var r = root(); if (!r) return;
    r.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!r.classList.contains('is-open')) r.hidden = true; }, 400);
  }
  function cartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; });
  }
  function change(key, qty) {
    var r = root(); if (r) r.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (res) { return res.json(); })
      .then(function (c) {
        setCount(c.item_count);
        if (document.querySelector('[data-dom-cart-page]')) { window.location.reload(); return; }
        return refresh();
      })
      .finally(function () { var r2 = root(); if (r2) r2.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dom-cart-open]');
    if (t && root()) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-dom-cart-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-dc-qty]');
    if (q) {
      var line = q.closest('[data-key]');
      if (line) { e.preventDefault(); change(line.getAttribute('data-key'), parseInt(q.getAttribute('data-dc-qty'), 10) || 0); }
    }
  });
  document.addEventListener('keydown', function (e) {
    var r = root();
    if (e.key === 'Escape' && r && r.classList.contains('is-open')) close();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add(\?|$)/.test(f.getAttribute('action') || '')) return;
    if (!root()) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
    var old = f.querySelector('.dc-error'); if (old) old.remove();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (r) {
        if (!r.ok) {
          var p = document.createElement('p'); p.className = 'dc-error'; p.setAttribute('role', 'alert');
          p.textContent = (r.j && (r.j.description || r.j.message)) || 'Sorry, something went wrong. Please try again.';
          f.appendChild(p); return;
        }
        return cartCount().then(refresh).then(open);
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });
})();
